import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './auth/login/login.component';
import {SignupComponent} from './auth/signup/signup.component';
import {CategoriesComponent} from './dashboard/categories/categories.component';
import {CreateArticleComponent} from './dashboard/create-article/create-article.component';
import {CreateCategoryComponent} from './dashboard/create-category/create-category.component';
import {CreateRatingCategoriesComponent} from './dashboard/create-rating-categories/create-rating-categories.component';
import {CreateUserComponent} from './dashboard/create-user/create-user.component';
import {EditCategoryComponent} from './dashboard/edit-category/edit-category.component';
import {EditEntityComponent} from './dashboard/edit-entity/edit-entity.component';
import {EditRatingCategoryComponent} from './dashboard/edit-rating-category/edit-rating-category.component';
import {EditUserDetailsComponent} from './dashboard/edit-user-details/edit-user-details.component';
import {EntitiesComponent} from './dashboard/entities/entities.component';
import {HomeComponent} from './dashboard/home/home.component';
import {NewEntityComponent} from './dashboard/new-entity/new-entity.component';
import {NewsComponent} from './dashboard/news/news.component';
import {RatingCategoriesComponent} from './dashboard/rating-categories/rating-categories.component';
import {ReviewEntityComponent} from './dashboard/review-entity/review-entity.component';
import {ReviewUsersComponent} from './dashboard/review-users/review-users.component';
import {SingleCategoryComponent} from './dashboard/single-category/single-category.component';
import {SingleEntityComponent} from './dashboard/single-entity/single-entity.component';
import {SingleNewsComponent} from './dashboard/single-news/single-news.component';
import {SingleReviewComponent} from './dashboard/single-review/single-review.component';
import {SuggestionsComponent} from './dashboard/suggestions/suggestions.component';
import {UserDetailsComponent} from './dashboard/user-details/user-details.component';
import {UsersComponent} from './dashboard/users/users.component';
import {WelcomeComponent} from './dashboard/welcome/welcome.component';
import {AuthGuardService} from './core/guards/auth.guard.service';
import {NoAuthGuardService} from './core/guards/no-auth.guard.service';
import {LayoutComponent} from './components/layout/layout.component';
import {NftCollectionComponent} from './dashboard/nft-collection/nft-collection.component';
import {NftCreateCollectionComponent} from './dashboard/nft-create-collection/nft-create-collection.component';
import {NftSingleCollectionComponent} from './dashboard/nft-single-collection/nft-single-collection.component';
import {BannersComponent} from './dashboard/banners/banners.component';
import {QuotesComponent} from './dashboard/quotes/quotes.component';
import {AddQuoteComponent} from './dashboard/quotes/add-quote/add-quote.component';
import {SurveysComponent} from './dashboard/surveys/surveys.component';
import {AddSurveyComponent} from './dashboard/surveys/add-survey/add-survey.component';
import {PodcastsComponent} from './dashboard/podcasts/podcasts.component';
import {IconsComponent} from './dashboard/icons/icons.component';
import {SuperCategoriesComponent} from './dashboard/super-categories/super-categories.component';
import {MarketplaceBooksComponent} from './dashboard/marketplace-books/marketplace-books.component';
import {MarketplaceProjectsComponent} from './dashboard/marketplace-projects/marketplace-projects.component';
import {MarketplaceProjectApplicationsComponent} from './dashboard/marketplace-project-applications/marketplace-project-applications.component';
import {UserFundingRecordsComponent} from './dashboard/user-funding-records/user-funding-records.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent, canActivate: [NoAuthGuardService]},
  {path: 'signup', component: SignupComponent, canActivate: [NoAuthGuardService]},
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuardService], children: [
      {path: '', component: WelcomeComponent},
      {path: 'users', component: UsersComponent},
      {path: 'users/user-funding', component: UserFundingRecordsComponent},
      {path: 'banners', component: BannersComponent},
      {path: 'icons', component: IconsComponent},
      {path: 'users/create-user', component: CreateUserComponent},
      {path: 'users/details/:id', component: UserDetailsComponent},
      {path: 'entities/single-entity/:id', component: SingleEntityComponent},
      {path: 'users/edit-details/:id', component: EditUserDetailsComponent},
      {path: 'entities', component: EntitiesComponent},
      {path: 'entities/create-entity', component: NewEntityComponent},
      {path: 'categories/create-category', component: CreateCategoryComponent},
      {path: 'ratings/create-rating-category', component: CreateRatingCategoriesComponent},
      {path: 'categories', component: CategoriesComponent},
      {path: 'super-categories', component: SuperCategoriesComponent},
      {path: 'rating-categories', component: RatingCategoriesComponent},
      {path: 'ratings/edit-rating-category/:id', component: EditRatingCategoryComponent},
      {path: 'categories/single-category/:id', component: SingleCategoryComponent},
      {path: 'categories/edit-category/:id', component: EditCategoryComponent},
      {path: 'users/review-user/:id', component: ReviewUsersComponent},
      {path: 'entities/review-entity/:id', component: ReviewEntityComponent},
      {path: 'entities/edit-entity/:id', component: EditEntityComponent},
      {path: 'single-review/:id', component: SingleReviewComponent},
      {path: 'home', component: HomeComponent},
      {path: 'news', component: NewsComponent},
      {path: 'news/new', component: CreateArticleComponent},
      {path: 'news/:id', component: SingleNewsComponent},
      {path: 'suggestions', component: SuggestionsComponent},
      {path: 'nfts-collection', component: NftCollectionComponent},
      {path: 'nfts/create-collection', component: NftCreateCollectionComponent},
      {path: 'nfts/single-collection/:id', component: NftSingleCollectionComponent},
      {path: 'claim', loadChildren: () => import('./modules/claim/claim.module').then(m => m.ClaimModule)},
      {path: 'memberships', loadChildren: () => import('./modules/membership/membership.module').then(m => m.MembershipModule)},
      {path: 'organizations', loadChildren: () => import('./modules/organization/organization.module').then(m => m.OrganizationModule)},
      {path: 'import', loadChildren: () => import('./modules/import-data/import-data.module').then(m => m.ImportDataModule)},
      {path: 'cms', loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule)},
      {path: 'management', loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule)},

      // quotes
      {path: 'quotes', component: QuotesComponent},
      {path: 'quotes/add-quote', component: AddQuoteComponent},

      // surveys
      {path: 'surveys', component: SurveysComponent},
      {path: 'surveys/add-survey', component: AddSurveyComponent},

      // podcasts
      {path: 'podcasts', component: PodcastsComponent},
      {path: 'marketplace/books', component: MarketplaceBooksComponent},
      {path: 'marketplace/projects', component: MarketplaceProjectsComponent, data: {marketplaceType: 'project'}},
      {path: 'marketplace/satire', component: MarketplaceProjectsComponent, data: {marketplaceType: 'satire'}},
      {path: 'marketplace/requests', component: MarketplaceProjectApplicationsComponent},

    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
